
import React from "react"

declare const UNDEFINED_VOID_ONLY: unique symbol

type Destructor = () => void | { [UNDEFINED_VOID_ONLY]: never }

type EffectCallback = () => (void | Destructor | Promise<any>)

export default function useAsyncEffect (effect: EffectCallback, deps?: readonly any[]) {
    React.useEffect(() => {
        (effect)()
    }, deps)
}
